import { gql } from '@apollo/client';
import React from 'react';
import Button from '../../components/Button';
import Buttons from '../../components/Buttons';
import type { UserProfileButtons_UserFragment } from '../../graphql/generated/graphqlTypes';
import emailIcon from '../../icons/email.svg';
import ExternalProfileButtons from './ExternalProfileButtons';

const USER_FRAGMENT = gql`
  fragment UserProfileButtons_user on User {
    id
    email
    importedFrom
    ...ExternalProfileButtons_user
  }
  ${ExternalProfileButtons.fragments.user}
`;

interface UserProfileButtonsProps {
  user: UserProfileButtons_UserFragment;
  size?: 'small' | 'regular';
}

const UserProfileButtons = ({
  user,
  size = 'regular',
}: UserProfileButtonsProps) => {
  const { email, importedFrom } = user;

  if (importedFrom) {
    return null;
  }

  return (
    <Buttons>
      {email && (
        <Button
          variant="secondary"
          size={size}
          to={`mailto:${email}`}
          target="_blank"
          icon={emailIcon}
        >
          Email
        </Button>
      )}
      <ExternalProfileButtons user={user} size={size} />
    </Buttons>
  );
};

UserProfileButtons.fragments = {
  user: USER_FRAGMENT,
};

export default UserProfileButtons;
